<div class="border bg-white pad15 position-relative">


  <div class="ctm-tab custom-card card-accord">
    <ng-container *ngIf="demandList?.length>0; else load_else">
      <ngb-accordion #acc="ngbAccordion" [activeIds]="activeIds" class="main">
        <ngb-panel id="toggle-{{i}}" *ngFor="let demand of demandList; let i=index">
          <ng-template ngbPanelHeader class="custom-header ctm">
            <div class="d-flex align-items-center">
              <button ngbPanelToggle translate class="btn d-flex w-100 align-items-center abc text-left" aria-label="Center Align">
                {{demand.demandNo}} - {{demand.shortDescription}}
                <div class="ml-auto d-flex">
                  <div class="mr-3" *ngIf="!demand.isUnderWarranty">
                    <em class="font20 icon-warranty text-muted"></em>
                  </div>
                  <div class="mr-3" *ngIf="demand.isUnderWarranty">
                    <span class="mr-2">Warranty</span>
                    <em class="font20 icon-warranty text-green"></em>
                  </div>
                  <div>
                    <em class="fas fa-angle-down fa-lg i1"></em>
                    <em class="fas fa-angle-up fa-lg i2"></em>
                  </div>

                </div>
              </button>
            </div>
          </ng-template>
          <ng-template ngbPanelContent>
            <app-dwo-diagnose-details
              [serviceFormName]="i"
              [serviceDiagnoseFormName]="'editDwoDiagnoseFormtoggle-' + i"
              [isSSM]="demand.isSSM"
              [demand]="demand"
            ></app-dwo-diagnose-details>
          </ng-template>
        </ngb-panel>
      </ngb-accordion>
    </ng-container>
    <ng-template #load_else>
      <p translate>lblNoRecordsFound</p>
    </ng-template>
  </div>
</div>
